// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Client from "@apollo/client";

var Js_ = {};

function make(uri, includeExtensions, $$fetch, headers, credentials, fetchOptions, useGETForQueries, param) {
  return new Client.HttpLink({
              uri: uri,
              includeExtensions: includeExtensions,
              fetch: $$fetch,
              headers: headers,
              credentials: credentials,
              fetchOptions: fetchOptions,
              useGETForQueries: useGETForQueries
            });
}

var ApolloLink;

var HttpOptions;

var UriFunction;

export {
  ApolloLink ,
  HttpOptions ,
  UriFunction ,
  Js_ ,
  make ,
}
/* @apollo/client Not a pure module */
